import React, { ChangeEvent } from 'react'
import {Box, createStyles, Grid, makeStyles, TextField, Typography, useMediaQuery} from "@material-ui/core";
import { useIntl } from 'react-intl';
import globalMessages from "../../../messages";
import contentMessages from "../messages";
import DeleteIcon from "@material-ui/icons/BackspaceOutlined";
import { ProviderThemeType, useMfwThemeProvider } from 'myfitworld-utils';
import ContentTutorialContainer from "./contentTutorial/ContentTutorialContainer";

interface ContentSearchFieldProps {
  onQueryChange?: (value: string) => void;
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  itemCount: number;
  loading: boolean;
  entityName?: string;
}
const createStylesForTheme = (mfwTheme: ProviderThemeType) => (theme: ProviderThemeType) =>
  makeStyles(() =>
    createStyles({
    fGrow1MTop10: { flexGrow: 1 },
    containerTop: {
      marginTop: 10,
      display: "flex",
      alignItems: "center",
    },
    containerIcon: {
      padding:"1px",
      fill: mfwTheme.theme.text.primary,
      marginLeft: 10,
      cursor: "pointer",
      transition: "color 0.2s ease",
      },
    })
  );

function ContentSearchField({ onQueryChange, setQuery, itemCount, query, loading, entityName }: ContentSearchFieldProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = e.target;
    if (onQueryChange) {
      onQueryChange(value || "");
    } else {
      setQuery(value);
    }
  };
  function handleClearSearch() {
    if (onQueryChange) {
      onQueryChange("");
    } else {
      setQuery("");
    }

  }
  
  const { formatMessage } = useIntl();
  const theme = useMfwThemeProvider();
  const useStyles = createStylesForTheme(theme.theme);
  const classes = useStyles(theme.theme)();
  const isMobile = useMediaQuery(theme.mfwMuiWebTheme.breakpoints.down('sm'));

  return (
    <Grid item md={3} xs={12}>
      <Box className={classes.containerTop}>
        <TextField
          label={formatMessage(contentMessages.searchfield_label)}
          placeholder={formatMessage(globalMessages.search_placeholder)}
          name="query"
          value = {query}
          onChange={handleChange}
          fullWidth
          className={classes.fGrow1MTop10}
        />
        <DeleteIcon fontSize='medium' className={classes.containerIcon} onClick={handleClearSearch} />
      </Box>

      <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        {!loading && (
          <Typography style={{marginTop: 10, color: theme.theme.theme.text.secondary, fontSize: 12, fontStyle: "italic"}}>
            {itemCount} {formatMessage(contentMessages.results)}
          </Typography>
        )}

        <Box style={{ marginTop: 10, marginRight: 40 }}>
          {isMobile && <ContentTutorialContainer entityName={entityName} />}
        </Box>
      </Box>
    </Grid>
  )
}

export default ContentSearchField
